/**
 * Document mode: which paragraph — and which character of it — is under a
 * viewport point, on whichever page that is.
 *
 * A drag-selection starts on one page but may end on another, and the pointer
 * stays captured by the page it started on; only each page knows its own
 * geometry. So every mounted page registers a tester here, and the drag asks
 * all of them.
 */
const testers = new Map();

export function registerDocHitTester(key, fn) {
    testers.set(key, fn);
    return () => {
        if (testers.get(key) === fn) testers.delete(key);
    };
}

/** `{ id, offset }` for the point, or null when it is not over any page. */
export function docHitTest(clientX, clientY) {
    for (const fn of testers.values()) {
        const hit = fn(clientX, clientY);
        if (hit) return hit;
    }
    return null;
}
